import React from 'react';
import { useSelector } from 'react-redux';
import { selectFutureActionsFilterVisible, selectTileView } from './store/selectors'; // Import the selector
import FutureActionsSearch from './future-actions-search';
import FutureActionsFilter from './future-actions-filter';
import FutureActionsTile from './future-actions-tile';
import FutureActionsTable from './future-actions-table';

const FutureActionsContent = () => {
  const isFilterVisible = useSelector(selectFutureActionsFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector
  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <FutureActionsSearch />
        </div>
        {isFilterVisible && <FutureActionsFilter />}

        {!showTileView ? <FutureActionsTile  /> : <FutureActionsTable />}
      </div>
    </div>
  );
};

export default FutureActionsContent;
